﻿'use strict';

angular.module('ntmApp').config(['$provide', function ($provide) {

    $provide.decorator('calendarTitle', ["moment", "calendarConfig", "calendarHelper", function (moment, calendarConfig, calendarHelper) {

        function day(viewDate) {
            return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.day);
        }

        function week(viewDate) {

            if (typeof calendarConfig.titleFormats.week === 'function') {
                return calendarConfig.titleFormats.week(viewDate);
            }

            return calendarConfig.titleFormats.week
              .replace('{week}', moment(viewDate).isoWeek())
              .replace('{year}', moment(viewDate).startOf('isoweek').format('YYYY'));
        }

        function month(viewDate) {
            return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.month);
        } 

        function year(viewDate) {
            return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.year);
        }

        return {
            day: day,
            week: week,
            month: month,
            year: year
        };

    }
    ]);
}]);